import savedGif from '../../../styles/images/ParSaved.gif';
import ReactDOM from 'react-dom';
import React, { useEffect, useRef, useState } from 'react';

import {
    Badge,
    Button,
    ButtonGroup,
    Card,
    Form,
    InputGroup,
    Navbar,
    Nav,
    Table,
    Container,
    Row,
    Col,
    OverlayTrigger,
    Tooltip,
    ListGroup,
    Modal,
    FormControl,
    Spinner


} from "react-bootstrap";

const ConfigureCloudRouterDevice = (props) => {
    const editMode = !!props.editMode;
    const existingRouter = props.existingRouter;

    // Canonical PLC port names (as stored in DB / produced by PortType.GetName()) -> frontend portType strings.
    const portNameToType = {
        'CAN0': 'smart1',
        'CAN1': 'smart2',
        'COW_A': 'classicA',
        'COW_B': 'classicB',
        'COW_C': 'classicC',
        'COW_D': 'classicD',
        'COW_E': 'classicE',
        'COW_F': 'classicF',
    };

    const buildDefaultPorts = () => ([
        { portType: 'smart1', parChargeBatch: false, parChargeMode: false },
        { portType: 'smart2', parChargeBatch: false, parChargeMode: false },
        { portType: 'classicA', parChargeBatch: false, parChargeMode: false },
        { portType: 'classicB', parChargeBatch: false, parChargeMode: false },
        { portType: 'classicC', parChargeBatch: false, parChargeMode: false },
        { portType: 'classicD', parChargeBatch: false, parChargeMode: false },
        { portType: 'classicE', parChargeBatch: false, parChargeMode: false },
        { portType: 'classicF', parChargeBatch: false, parChargeMode: false },
    ]);

    const [cloudRouterArray, setCloudRouterArray] = useState([]);

    const [cloudRouterAddress, setCloudRouterAddress] = useState("");

    const [showPortSetup, setShowPortSetup] = useState(false);


    const [showCDCSetup, setShowCDCSetup] = useState(true);

    const [checkedSmart1Batch, setCheckedSmart1Batch] = useState(false);

    const [selectedCloudRouter, setSelectedCloudRouter] = useState();

    const [step1LoaderCDC, setStep1LoaderCDC] = useState(false);

    const [foundRouterCDC, setFoundRouterCDC] = useState();
    const [showCDCInput, setShowCDCInput] = useState(!editMode);
    const [errorCDC, setErrorCDC] = useState(false);
    const [successCDC, setSuccessCDC] = useState(false);

    const [showCloudRouterInfo, setShowCloudRouterInfo] = useState(false);

    // Tracks the auto-close setTimeout so it can be cancelled if the modal closes early
    // (e.g. user dismisses via X). Without this, the stale timer would fire later and
    // close the next modal the user opens.
    const closeTimeoutRef = useRef(null);
    const isSubmittingRef = useRef(false);

    useEffect(() => {
        return () => {
            if (closeTimeoutRef.current) {
                clearTimeout(closeTimeoutRef.current);
                closeTimeoutRef.current = null;
            }
        };
    }, []);

    useEffect(() => {
        if (editMode) {
            // Skip the unassigned-routers picker; load the existing PLC's ports instead.
            return;
        }
        fetch('api/Router/GetAllRoutersUnassigned')
            .then(response => response.json())
            .then(data => {
                if (data.routers.length > 0) {
                    setCloudRouterArray(data.routers);
                }
            });
    }, [editMode]);

    useEffect(() => {
        if (!editMode || !existingRouter || !existingRouter.id) {
            return;
        }

        const address = (existingRouter.address || "").trim();
        setCloudRouterAddress(address);

        const buildRouterCard = (firmwareVersion, isRunning) => (
            <div className="card-data dataCardCR my-3 card">
                <ul className="listview flush transparent image-listview">
                    <li>
                        <div className="item">
                            <div className="icon-box bg-white"><i className="text-primary fas fa-wifi"></i></div>
                            <div className="in">{address}</div>
                        </div>
                    </li>
                    <li>
                        <div className="item">
                            <div className="icon-box bg-white"><i className="text-primary fas fa-cloud-download-alt"></i></div>
                            <div className="in">Firmware<span className="text-right pl-05 locationNameRO text-bold">{firmwareVersion || "—"}</span></div>
                        </div>
                    </li>
                    <li>
                        <div className="item">
                            <div className="icon-box bg-white"><i className="text-primary fas fa-signal"></i></div>
                            <div className="in">Router Status<span className="text-right text-bold">{isRunning ? <div className="text-success">Online</div> : <div className="text-danger">Offline</div>}</span></div>
                        </div>
                    </li>
                </ul>
            </div>
        );

        setFoundRouterCDC(buildRouterCard(existingRouter.firmwareVersion, existingRouter.isRunning));

        fetch(`api/Controller/GetByRouterId/${existingRouter.id}`)
            .then(response => (response.status === 204 ? { controllers: [] } : response.json()))
            .then(data => {
                const ports = buildDefaultPorts();
                const controllers = (data && data.controllers) || [];
                for (const c of controllers) {
                    const portType = portNameToType[(c.portName || "").trim()];
                    if (!portType) continue;
                    const port = ports.find(p => p.portType === portType);
                    if (port) {
                        port.parChargeMode = !!c.parChargeMode;
                        port.parChargeBatch = !!c.parChargeBatch;
                    }
                }

                setSelectedCloudRouter({
                    routerAddress: address,
                    ports,
                    tenantId: props.tenantId,
                });
                setShowPortSetup(true);
            })
            .catch(err => {
                console.log(err);
                setSelectedCloudRouter({
                    routerAddress: address,
                    ports: buildDefaultPorts(),
                    tenantId: props.tenantId,
                });
                setShowPortSetup(true);
            });
    }, [editMode, existingRouter, props.tenantId]);

    const portInitial = (portType, field) => {
        if (!selectedCloudRouter || !selectedCloudRouter.ports) return false;
        const p = selectedCloudRouter.ports.find(x => x.portType === portType);
        return p ? !!p[field] : false;
    };

    
    let routerConfigCDC = <h1>TEST</h1>
 
    const checkNewCloudRouter = async (valPassed) => {

        let foundValue = false;
        const normalized = (valPassed || "").trim();
        setCloudRouterAddress(normalized);
        // Match API/DB trimming — padded addresses in the list would otherwise never === user input.
        if (normalized.length === 14) {
            
            console.log(cloudRouterArray)
            for (var i = 0; i < cloudRouterArray.length; i++) {
                //FOUND ROUTER 

                if ((cloudRouterArray[i].address || "").trim() === normalized) {
                    foundValue = true;
                   
                 

                    let routerConfigCDC = <div className="card-data dataCardCR my-3 card">
                      
                        <ul className="listview flush transparent image-listview">
                            <li>
                                <div className="item">
                                    <div className="icon-box bg-white"><i className="text-primary fas fa-wifi"></i></div>


                                    <div className="in">{cloudRouterArray[i].address}<div onClick={() => { setShowCDCInput(true); setShowPortSetup(false) }} className="mt-1 btn btn-sm btn-remove-color ">Remove</div></div>
                                </div>
                            </li>
                            <li>
                                <div className="item">
                                    <div className="icon-box bg-white"><i className="text-primary fas fa-cloud-download-alt"></i></div>
                                    <div className="in">Firmware<span className="text-right pl-05 locationNameRO text-bold">{cloudRouterArray[i].firmwareVersion}</span></div>
                                </div>
                            </li>
                            <li>
                                <div className="item">
                                    <div className="icon-box bg-white"><i className="text-primary fas fa-signal"></i></div>
                                    <div className="in">Router Status<span className="text-right text-bold">{cloudRouterArray[i].isRunning ? <div className="text-success">Online</div> : <div className="text-danger">Offline</div> }</span></div>
                                </div>
                            </li>
                        </ul>
                    </div>











                     
                    setFoundRouterCDC(routerConfigCDC)


               
                  
                    setShowPortSetup(true)



                    let portsArray = [];

                    portsArray.push({ portType: 'smart1', parChargeBatch: false, parChargeMode: false })
                    portsArray.push({ portType: 'smart2', parChargeBatch: false, parChargeMode: false })
                    portsArray.push({ portType: 'classicA', parChargeBatch: false, parChargeMode: false })
                    portsArray.push({ portType: 'classicB', parChargeBatch: false, parChargeMode: false })
                    portsArray.push({ portType: 'classicC', parChargeBatch: false, parChargeMode: false })
                    portsArray.push({ portType: 'classicD', parChargeBatch: false, parChargeMode: false })
                    portsArray.push({ portType: 'classicE', parChargeBatch: false, parChargeMode: false })
                    portsArray.push({ portType: 'classicF', parChargeBatch: false, parChargeMode: false })


                    let objCloudRouter = {
                        routerAddress: normalized, ports: portsArray, tenantId: props.tenantId
                    };

                    setSelectedCloudRouter(objCloudRouter);
                    setShowCDCInput(false)
                    console.log(objCloudRouter);
                    
                    break;
                }
            }
        }

        if (foundValue == false) {

            setShowPortSetup(false);

        }

    }





    if (foundRouterCDC)
    {
        routerConfigCDC = foundRouterCDC
    }


    const portsChecked = async (e) => {

        setCheckedSmart1Batch(e.target.value)
        let idOfInput = e.target.id;
        //objCloudRouter
        let nameOfInput = e.target.getAttribute("data-port");
        console.log(idOfInput);
        console.log(nameOfInput);


        let ports = selectedCloudRouter.ports;
        for (var i = 0; i < ports.length; i++) {
            if (idOfInput.includes(ports[i].portType)) {

                if (idOfInput.includes('RapidRead')) {
                    if (e.target.checked == true) {
                        ports[i].parChargeMode = true
                    }
                    else {
                        ports[i].parChargeMode = false
                    }

                }

                else if (idOfInput.includes('BatchMode')) {
                    if (e.target.checked == true) {
                        ports[i].parChargeBatch = true
                    }
                    else {
                        ports[i].parChargeBatch = false
                    }

                }

                break;
            }

            setSelectedCloudRouter({ routerAddress: cloudRouterAddress, ports: ports, tenantId: props.tenantId });
        }

        console.log(selectedCloudRouter)

    }
        
    const registerNewCloudRouter = async () => {

        if (isSubmittingRef.current) {
            return;
        }
        isSubmittingRef.current = true;

        try {
            const url = "api/Router/CreateCloudRouter";
            setStep1LoaderCDC(true)
            setShowCDCSetup(false)

            setShowCloudRouterInfo(false)

            const response = await fetch(url,
                {
                    method: "post",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    }),
                    body: JSON.stringify(selectedCloudRouter),
                });


            if (response.status === 400) {
                await response.json().catch(() => ({}));
                setStep1LoaderCDC(false);
                setErrorCDC(true);
            }
            else if (response.status === 200) {
              
                let responseBody = await response.json();
                console.log(responseBody)
                setSuccessCDC(true)
                if (closeTimeoutRef.current) {
                    clearTimeout(closeTimeoutRef.current);
                }
                closeTimeoutRef.current = setTimeout(() => {
                    closeTimeoutRef.current = null;
                    closeModal();
                }, 3000);

            } else {
                setStep1LoaderCDC(false)

                setErrorCDC(true)
            }


        } catch (e) {
            console.log(e);
        }


        setStep1LoaderCDC(false)
        isSubmittingRef.current = false;

    }

    const closeModal = () => {

   
    props.onAddRouterComplete();
}
    let loaderCDC = (step1LoaderCDC) ?
        <div className="row m-5">
            <div className="col m-5">
                <div className="wifi-loader">
                    <svg className="circle-outer" viewBox="0 0 86 86">
                        <circle className="back" cx="43" cy="43" r="40"></circle>
                        <circle className="front" cx="43" cy="43" r="40"></circle>
                        <circle className="new" cx="43" cy="43" r="40"></circle>
                    </svg>
                    <svg className="circle-middle" viewBox="0 0 60 60">
                        <circle className="back" cx="30" cy="30" r="27"></circle>
                        <circle className="front" cx="30" cy="30" r="27"></circle>
                    </svg>
                    <svg className="circle-inner" viewBox="0 0 34 34">
                        <circle className="back" cx="17" cy="17" r="14"></circle>
                        <circle className="front" cx="17" cy="17" r="14"></circle>
                    </svg>
                    <div className=" cloudRouterLoaderText text" data-text={editMode ? "Updating CDC Router" : "Creating CDC Router"}></div>
                </div>
            </div>
        </div>
        : undefined;





   
    let loaderCDCError = (errorCDC) ?

        <div className="row m-5">
            <div className="text-center col p-0 ">
                <div className="dangerIconGif">





                    <div className="ui-error">
                        <svg viewBox="0 0 87 87" version="1.1">
                            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g id="Group-2" transform="translate(2.000000, 2.000000)">
                                    <circle id="Oval-2" stroke="rgba(252, 191, 191, .5)" strokeWidth="4" cx="41.5" cy="41.5" r="41.5"></circle>
                                    <circle className="ui-error-circle" stroke="#F74444" strokeWidth="4" cx="41.5" cy="41.5" r="41.5"></circle>
                                    <path className="ui-error-line1" d="M22.244224,22 L60.4279902,60.1837662" id="Line" stroke="#F74444" strokeWidth="3" strokeLinecap="square"></path>
                                    <path className="ui-error-line2" d="M60.755776,21 L23.244224,59.8443492" id="Line" stroke="#F74444" strokeWidth="3" strokeLinecap="square"></path>
                                </g>
                            </g>
                        </svg>
                    </div>



                </div>
                <h5>{editMode ? "Oops! There was an Error Updating the CDC Controller" : "Oops! There was an Error Creating the CDC Controller"}</h5>
            </div>
        </div>
        : undefined;



    let loaderCDCSuccess = (successCDC) ?
        <div className="row m-5">
            <div className="text-center col p-0 ">
                <div className="dangerIconGif">
                    <div className="ui-error">
                        <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                            <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                            <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                        </svg>
                    </div>
                </div>
                <h5>{editMode ? "CDC Controller Successfully Updated" : "CDC Controller Successfully Created"}</h5>
            </div>
        </div>
        : undefined;



    return (
        <Container fluid>
           
            {showCDCSetup ? <div><h3>{editMode ? "Edit Cloud Router" : "Cloud Router Setup"}</h3>















                <div id="modifyCloudRouter">

                    <Row>
                        {showCDCInput ?
                            <div className="py-3 col-12">
                                <h5 className="mt-2 mb-2">Available Cloud Routers</h5>
                                {cloudRouterArray.length === 0 ? (
                                    <div className="card-data dataCardCR my-3 card">
                                        <ul className="listview flush transparent image-listview">
                                            <li>
                                                <div className="item">
                                                    <div className="icon-box bg-white"><i className="text-muted fas fa-inbox"></i></div>
                                                    <div className="in">
                                                        <div>
                                                            <div className="text-bold">No unassigned Cloud Routers available</div>
                                                            <div className="text-muted text-13">Once a Cloud Router is registered and unassigned, it will appear here.</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                ) : (
                                    <div className="card-data dataCardCR my-3 card">
                                        <ul className="listview flush transparent image-listview">
                                            {cloudRouterArray.map((obj, key) => {
                                                const address = (obj.address || "").trim();
                                                return (
                                                    <li key={address || key} role="button" style={{ cursor: 'pointer' }} onClick={() => checkNewCloudRouter(address)}>
                                                        <div className="item">
                                                            <div className="icon-box bg-white"><i className="text-primary fas fa-wifi"></i></div>
                                                            <div className="in">
                                                                <div>
                                                                    <div className="text-bold">{address}</div>
                                                                    <div className="text-muted text-13">Firmware {obj.firmwareVersion || "—"}</div>
                                                                </div>
                                                                <span className="text-right text-bold">
                                                                    {obj.isRunning ? (
                                                                        <span className="text-success">Online</span>
                                                                    ) : (
                                                                        <span className="text-danger">Offline</span>
                                                                    )}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                )}
                            </div>
                            :
                            <div className="col-12">
                                {routerConfigCDC}
                                </div>
                        }
                        
                    </Row >









                    {showPortSetup ?
                        <div>

                            <h4 className=" mt-3 mb-0">Port Setup:</h4>
                            <Row>
                                <div className="col-md-3">
                                    <div data-port-name="CAN0" className=" dataCardModifyCR card-data my-3 card">
                                        <ul className="listview flush transparent image-listview">
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-primary fas fa-ethernet"></i></div>
                                                    <div className="in"><span data-portname="CAN0" className="portNameModify text-right text-bold">Smart1</span><span className="text-muted text-13 ml-2">CAN0</span></div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-yellow fas fa-bolt"></i></div>
                                                    <div className="in">
                                                        <div>Rapid Read</div>
                                                        <div className="custom-control custom-switch">
                                                            <input defaultChecked={portInitial('smart1', 'parChargeMode')} onChange={(e) => portsChecked(e)} type="checkbox" className="inputParCR0 parChargeModeInput custom-control-input" data-port="smart1" id="smart1RapidRead" /> <label className="custom-control-label custom-control-label-on" htmlFor="smart1RapidRead"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-warning fas fa-bolt"></i></div>
                                                    <div className="in">
                                                        <div>Par Charge</div>
                                                        <div className="custom-control custom-switch">
                                                            <input defaultChecked={portInitial('smart1', 'parChargeBatch')} onChange={(e) => portsChecked(e)} type="checkbox" className="inputParCR0 parBatchModeInput custom-control-input" data-port="smart1" id="smart1BatchMode" /> <label className="custom-control-label custom-control-label-on" htmlFor="smart1BatchMode"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div data-port-name="CAN1" className=" dataCardModifyCR card-data my-3 card">
                                        <ul className="listview flush transparent image-listview">
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-primary fas fa-ethernet"></i></div>
                                                    <div className="in"><span data-portname="CAN1" className="portNameModify text-right text-bold">Smart2</span><span className="text-muted text-13 ml-2">CAN1</span></div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-yellow fas fa-bolt"></i></div>
                                                    <div className="in">
                                                        <div>Rapid Read</div>
                                                        <div className="custom-control custom-switch">
                                                            <input defaultChecked={portInitial('smart2', 'parChargeMode')} onChange={(e) => portsChecked(e)} type="checkbox" className="inputParCR1 parChargeModeInput custom-control-input" data-port="smart2" id="smart2RapidRead" /> <label className="custom-control-label custom-control-label-on" htmlFor="smart2RapidRead"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-warning fas fa-bolt"></i></div>
                                                    <div className="in">
                                                        <div>Par Charge</div>
                                                        <div className="custom-control custom-switch">
                                                            <input defaultChecked={portInitial('smart2', 'parChargeBatch')} onChange={(e) => portsChecked(e)} type="checkbox" className="inputParCR1 parBatchModeInput custom-control-input" data-port="smart2" id="smart2BatchMode" /> <label className="custom-control-label custom-control-label-on" htmlFor="smart2BatchMode"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div data-port-name="COW_A" className=" dataCardModifyCR card-data my-3 card">
                                        <ul className="listview flush transparent image-listview">
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-primary fas fa-ethernet"></i></div>
                                                    <div className="in"><span className="portNameModify text-right text-bold">ClassicA</span><span className="text-muted text-13 ml-2">COW_A</span></div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-warning fas fa-bolt"></i></div>
                                                    <div className="in">
                                                        <div>Par Charge</div>
                                                        <div className="custom-control custom-switch">
                                                            <input defaultChecked={portInitial('classicA', 'parChargeBatch')} onChange={(e) => portsChecked(e)} type="checkbox" className="inputParCR2 parBatchModeInput custom-control-input" data-port="classicA" id="classicABatchMode" /> <label className="custom-control-label custom-control-label-on" htmlFor="classicABatchMode"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div data-port-name="COW_B" className=" dataCardModifyCR card-data my-3 card">
                                        <ul className="listview flush transparent image-listview">
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-primary fas fa-ethernet"></i></div>
                                                    <div className="in"><span className="portNameModify text-right text-bold">ClassicB</span><span className="text-muted text-13 ml-2">COW_B</span></div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-warning fas fa-bolt"></i></div>
                                                    <div className="in">
                                                        <div>Par Charge</div>
                                                        <div className="custom-control custom-switch">
                                                            <input defaultChecked={portInitial('classicB', 'parChargeBatch')} onChange={(e) => portsChecked(e)} type="checkbox" className="inputParCR3 parBatchModeInput custom-control-input" data-port="classicB" id="classicBBatchMode" /> <label className="custom-control-label custom-control-label-on" htmlFor="classicBBatchMode"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </Row>




                            <Row>
                                <div className="col-md-3">
                                    <div data-port-name="COW_C" className="dataCardModifyCR card-data my-3 card">
                                        <ul className="listview flush transparent image-listview">
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-primary fas fa-ethernet"></i></div>
                                                    <div className="in"><span className="portNameModify text-right text-bold">ClassicC</span><span className="text-muted text-13 ml-2">COW_C</span></div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-warning fas fa-bolt"></i></div>
                                                    <div className="in">
                                                        <div>Par Charge</div>
                                                        <div className="custom-control custom-switch">
                                                            <input defaultChecked={portInitial('classicC', 'parChargeBatch')} onChange={(e) => portsChecked(e)} type="checkbox" className="inputParCR4 parBatchModeInput custom-control-input" data-port="classicC" id="classicCBatchMode" /> <label className="custom-control-label custom-control-label-on" htmlFor="classicCBatchMode"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div data-port-name="COW_D" className="dataCardModifyCR card-data my-3 card">
                                        <ul className="listview flush transparent image-listview">
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-primary fas fa-ethernet"></i></div>
                                                    <div className="in"><span className="portNameModify text-right text-bold">ClassicD</span><span className="text-muted text-13 ml-2">COW_D</span></div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-warning fas fa-bolt"></i></div>
                                                    <div className="in">
                                                        <div>Par Charge</div>
                                                        <div className="custom-control custom-switch">
                                                            <input defaultChecked={portInitial('classicD', 'parChargeBatch')} onChange={(e) => portsChecked(e)} type="checkbox" className="inputParCR5 parBatchModeInput custom-control-input" data-port="classicD" id="classicDBatchMode" /> <label className="custom-control-label custom-control-label-on" htmlFor="classicDBatchMode"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                                <div className="col-md-3">
                                    <div data-port-name="COW_E" className="dataCardModifyCR card-data my-3 card">
                                        <ul className="listview flush transparent image-listview">
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-primary fas fa-ethernet"></i></div>
                                                    <div className="in"><span className="portNameModify text-right text-bold">ClassicE</span><span className="text-muted text-13 ml-2">COW_E</span></div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-warning fas fa-bolt"></i></div>
                                                    <div className="in">
                                                        <div>Par Charge</div>
                                                        <div className="custom-control custom-switch">
                                                            <input defaultChecked={portInitial('classicE', 'parChargeBatch')} onChange={(e) => portsChecked(e)} type="checkbox" className="inputParCR6 parBatchModeInput custom-control-input" data-port="classicE" id="classicEBatchMode" /> <label className="custom-control-label custom-control-label-on" htmlFor="classicEBatchMode"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div data-port-name="COW_F" className="dataCardModifyCR card-data my-3 card">
                                        <ul className="listview flush transparent image-listview">
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-primary fas fa-ethernet"></i></div>
                                                    <div className="in"><span className="portNameModify text-right text-bold">ClassicF</span><span className="text-muted text-13 ml-2">COW_F</span></div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="p-1 item">
                                                    <div className="icon-box bg-white mr-1"><i className="text-warning fas fa-bolt"></i></div>
                                                    <div className="in">
                                                        <div>Par Charge</div>
                                                        <div className="custom-control custom-switch">
                                                            <input defaultChecked={portInitial('classicF', 'parChargeBatch')} onChange={(e) => portsChecked(e)} type="checkbox" className="inputParCR7 parBatchModeInput custom-control-input" data-port="classicF" id="classicFBatchMode" /> <label className="custom-control-label custom-control-label-on" htmlFor="classicFBatchMode"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </Row>

                            <Row className="justify-content-center"> <div onClick={() => registerNewCloudRouter()} className="mt-4 btn btn-md btn-primary">{editMode ? "Update CDC Router" : "Create CDC Router"}</div></Row>
                        </div>
                        : null}
                </div>

            </div> : null
                }

            {loaderCDC}
            {loaderCDCSuccess}
            {loaderCDCError}
        </Container>
    );
}

export default ConfigureCloudRouterDevice;